import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

window.Swiper = window.Swiper || Swiper;
function initHeroSwiper() {
  const els = document.querySelectorAll('.heroSwiper');
  if (!els.length) return;

  els.forEach(el => {
    const slides = el.querySelectorAll('.swiper-slide');
    if (slides.length < 2) return;

    const delay = Number(el.dataset.delay) || 5000;

    new Swiper(el, {
      modules: [Navigation, Pagination, Autoplay, EffectFade],
      slidesPerView: 1,
      loop: true,
      effect: 'fade',
      fadeEffect: { crossFade: true },
      speed: 1500,
      autoplay: {
        delay: delay,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: el.querySelector('.swiper-button-next'),
        prevEl: el.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: el.querySelector('.swiper-pagination'),
        clickable: true,
        renderBullet: function (index, className) {
          const slide = slides[index];
          const img = slide?.querySelector('img');
          const thumb = img?.getAttribute('data-thumb') || '';
          const text = slide?.querySelector('a.hero-button')?.textContent?.trim() || '';
          return `<span class="${className}" data-title="${text}" style="background-image:url('${thumb}'); background-size:cover; background-position:center;"></span>`;
        }

      }
    });
  });
}

document.addEventListener('DOMContentLoaded', initHeroSwiper);
